import React, { useRef, useState } from "react";
import { Accordion, Button, Modal, Spinner } from "react-bootstrap";
import amazon from "../Phonepe/img/amazon.png";
import bag from "../Phonepe/img/bag.png";
import bhim from "../Phonepe/img/bhim.png";
import cred from "../Phonepe/img/cred.png";
import gpay from "../Phonepe/img/gpay.png";
import paytm from "../Phonepe/img/paytm.png";
import phonepay from "../Phonepe/img/phonepe.png";
import upi from "../Phonepe/img/upi.png";
import Loading from "../Phonepe/Loading";
import email from "../Phonepe/img/outline_alternate_email.png";
import debit from "../Phonepe/img/debit.svg";
import netBanking from "../Phonepe/img/net.svg";
import { BsExclamationCircle } from "react-icons/bs";
import PhonePeImg from "../Phonepe/img/phonepe_horizontal.png";
import icici from "../Phonepe/img/ICIC.png";
import Axix from "../Phonepe/img/UTIB.png";
import Kotat from "../Phonepe/img/KKBK.png";
import PhonePeQrImg from "../Phonepe/img/phonepe-qr-img.png";
import { QRCode } from "react-qrcode-logo";

const PayhubPay = ({
  isOpen,
  onClose,
  title,
  handlePayhubPayment,
  amount = 0,
  checkStatusLoading = false,
}) => {
  const [showMore, setShowMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [activeKey, setActiveKey] = useState(0);
  const [selectedApp, setSelectedApp] = useState("PhonePe");
  const [upiInput, setUpiInput] = useState("");
  const qrRef = useRef();
  const qrCode = process.env.REACT_APP_QR;

  const BanksData = [
    { name: "ICICI", img: icici },
    { name: "Axix Bank", img: Axix },
    { name: "Kotak", img: Kotat },
  ];
  const upiURL = `upi://pay?pa=${qrCode}&pn=${"chirag"}&am=${amount}&cu=INR`;

  const upiApps = [
    { name: "PhonePe", img: phonepay },
    { name: "Google Pay", img: gpay },
    { name: "Paytm", img: paytm },
    { name: "CRED", img: cred },
    { name: "Amazon Pay", img: amazon },
    { name: "Bhim", img: bhim },
  ];
  const maxVisible = 4;
  const appsToShow = showMore ? upiApps : upiApps.slice(0, maxVisible);

  const appBoxStyle = (isSelected) => ({
    borderRadius: 8,
    border: `1.5px solid ${isSelected ? "#9b59b6" : "transparent"}`,
    backgroundColor: isSelected ? "#f3e9fb" : "#fff",
    cursor: "pointer",
    height: 88,
    minWidth: 80,
    padding: "10px 0",
    textAlign: " center",
    width: "100%",
  });
  const getAccordionSpacing = (key) => {
    if (activeKey === key) {
      if (key === 0) return { marginBottom: "20px" };
      if (key === 1) return { margin: "20px 0" };
      if (key === 2) return { margin: "20px 0" };
      if (key === 3) return { marginTop: "20px" };
    }
    return {};
  };

  return (
    <>
      <React.Fragment>
        <Modal
          show={openModal}
          onHide={onClose}
          centered
          className="small-dialog"
          animation={false}
        >
          <Modal.Body>
            <p className="m-0 fs-6">
              Are you sure you want to cancel this transaction?
            </p>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0">
            <Button
              className="fw-semibold border-0 bg-transparent text-dark"
              onClick={() => setOpenModal(false)}
            >
              No
            </Button>
            <Button
              className="fw-semibold border-0 bg-transparent text-dark"
              onClick={() => {
                onClose();
                setTimeout(() => {
                  localStorage.removeItem("transaction-key");
                }, 3000); // 3 sec
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={isOpen}
          onHide={() => setOpenModal(true)}
          centered
          animation={false}
          className="gateway-modal"
        >
          <Modal.Header
            closeButton
            style={{ borderBottom: "1px solid #dee2e6" }}
          >
            <Modal.Title>
              <div className="d-flex align-items-center gap-2">
                <img src={bag} alt="bag" width={30} height={30} />
                <h5 style={{ margin: 0 }}>{title}</h5>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              backgroundColor: checkStatusLoading ? "#fff" : "#F1E5F9",
              padding: checkStatusLoading ? 0 : "",
            }}
          >
            {checkStatusLoading ? (
              <div className="w-100 d-flex align-items-center justify-content-center flex-column h-100">
                <Spinner
                  style={{
                    borderColor: "#6720A4",
                    borderRightColor: "transparent",
                  }}
                />
                <p className="mt-2">Please Wait</p>
              </div>
            ) : (
              <>
                <Accordion
                  activeKey={activeKey}
                  onSelect={(e) => setActiveKey(e)}
                >
                  <style>
                    {`
                              .accordion-button::after {
                                display: none !important;
                              }
                              .accordion-button:not(.collapsed) {
                                background-color: transparent !important;
                                box-shadow: none !important;
                                color: inherit !important;
                              }
                              .accordion-button:focus {
                                box-shadow: none !important;
                              }
                              .custom-radio {
                                width: 20px;
                                height: 20px;
                                border-radius: 50%;
                                border: 2px solid #ccc;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 12px;
                                transition: all 0.2s ease;
                              }  
                              .custom-radio.active {
                                background-color: #28a745;
                                border-color: #28a745;
                                color: white;
                              }
                            
                              .custom-radio input {
                                display: none;
                              }
                              .accordion-item {
                                transition: margin 0.3s ease;margin:0 !important;
                              }
                            `}
                  </style>
                  <Accordion.Item eventKey={0} style={getAccordionSpacing(0)}>
                    <Accordion.Header>
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-start">
                          <img
                            src={upi}
                            alt="upi"
                            width={30}
                            height={30}
                            className="me-3"
                          />
                          <div className="d-flex flex-column">
                            <div className="mb-0 fw-bold">UPI Apps</div>
                            <p className="mb-0" style={{ fontSize: "12px" }}>
                              Instant payment via UPI apps or UPI ID
                            </p>
                          </div>
                        </div>

                        <div
                          className={`custom-radio ${
                            activeKey === 0 ? "active" : ""
                          }`}
                          onClick={() => setActiveKey(0)}
                        >
                          {activeKey === 0 && "✓"}
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="card border-0">
                        <div
                          className="d-grid gap-2 mt-0"
                          style={{
                            gridTemplateColumns:
                              "repeat(auto-fill, minmax(72px, 1fr))",
                          }}
                        >
                          {appsToShow.map((app, index) => (
                            <div
                              key={index}
                              className="d-flex flex-column align-items-center justify-content-start"
                              style={appBoxStyle(selectedApp === app.name)}
                              onClick={() => {
                                setSelectedApp(app.name);
                                setLoading(false);
                              }}
                            >
                              {loading && selectedApp === app.name ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                  }}
                                >
                                  <Loading removeBG />
                                </div>
                              ) : (
                                <>
                                  <img
                                    src={app.img}
                                    alt={app.name}
                                    width={40}
                                    height={40}
                                    className="mb-1"
                                  />
                                  <p
                                    className="mb-0"
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {app.name}
                                  </p>
                                </>
                              )}
                            </div>
                          ))}

                          {!showMore && upiApps.length > maxVisible && (
                            <div
                              className="d-flex flex-column align-items-center justify-content-start"
                              onClick={() => setShowMore(true)}
                              style={{
                                height: 88,
                                padding: "8px 0",
                              }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-center mb-1"
                                style={{
                                  marginTop: "8px",
                                  width: 36,
                                  height: 36,
                                  padding: "8px 0",
                                  border: "1px solid #ccc",
                                  borderRadius: 10,
                                  cursor: "pointer",
                                }}
                              >
                                <span style={{ fontSize: "18px" }}>...</span>
                              </div>
                              <p
                                className="mb-0"
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                }}
                              >
                                Other
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey={1} style={getAccordionSpacing(1)}>
                    <Accordion.Header>
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-start">
                          <img
                            src={email}
                            alt="email"
                            width={35}
                            height={35}
                            className="me-3"
                          />
                          <div className="d-flex flex-column">
                            <div className="mb-0 fw-bold">UPI ID</div>
                            <p className="mb-0" style={{ fontSize: "12px" }}>
                              PhonePe, Google Pay, Paytm, BHIM & more
                            </p>
                          </div>
                        </div>

                        <div
                          className={`custom-radio ${
                            activeKey === 1 ? "active" : ""
                          }`}
                          onClick={() => setActiveKey(1)}
                        >
                          {activeKey === 1 && "✓"}
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="card border-0">
                        <div className="pb-3 text-center" ref={qrRef}>
                          {qrCode ? (
                            <QRCode
                              value={upiURL}
                              ecLevel="L"
                              size={150}
                              logoImage={PhonePeQrImg}
                              logoWidth={35}
                              logoHeight={35}
                              logoOpacity={1}
                              removeQrCodeBehindLogo={true}
                            />
                          ) : (
                            <p>No QR code available</p>
                          )}
                        </div>
                        <div
                          className="d-grid gap-2 mt-0"
                          style={{
                            gridTemplateColumns:
                              "repeat(auto-fill, minmax(72px, 1fr))",
                          }}
                        >
                          {upiApps.slice(0, 3).map((app, index) => (
                            <div
                              key={index}
                              className="d-flex cursor-pointer flex-column align-items-center justify-content-start"
                              style={{
                                paddingBottom: "8px",
                                borderBottom:
                                  selectedApp === app.name
                                    ? "2px solid purple"
                                    : "2px solid transparent",
                              }}
                              onClick={() => {
                                setSelectedApp(app.name);
                                setShowMore(false);
                              }}
                            >
                              <img
                                src={app.img}
                                alt={app.name}
                                width={30}
                                height={30}
                                className="mb-1"
                              />
                              <p
                                className="mb-0"
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                }}
                              >
                                {app.name}
                              </p>
                            </div>
                          ))}

                          {upiApps.length > maxVisible && (
                            <div
                              className="d-flex flex-column cursor-pointer align-items-center justify-content-start"
                              onClick={() => {
                                setShowMore(true);
                                setSelectedApp("Other");
                              }}
                              style={{
                                paddingBottom: "8px",
                                borderBottom:
                                  selectedApp === "Other"
                                    ? "2px solid purple"
                                    : "2px solid transparent",
                              }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-center mb-1"
                                style={{
                                  width: 30,
                                  height: 30,
                                  paddingBottom: "6px",
                                  marginTop: "2px",
                                  border: "1px solid #ccc",
                                  borderRadius: 10,
                                }}
                              >
                                <span style={{ fontSize: "18px" }}>...</span>
                              </div>
                              <p
                                className="mb-0"
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                }}
                              >
                                Other
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="position-relative mt-3">
                          {!showMore && (
                            <select
                              className="form-select position-absolute"
                              style={{
                                width: "100px",
                                right: "6px",
                                top: "4px",
                                backgroundColor: "#ECEFF1",
                                height: "30px",
                                fontSize: "12px",
                                outline: "none",
                                boxShadow: "none",
                                border: "none",
                              }}
                            >
                              {selectedApp === "PhonePe" &&
                                ["ybl", "ibl", "axl"].map((opt) => (
                                  <option key={opt}>{opt}</option>
                                ))}
                              {selectedApp === "Google Pay" &&
                                [
                                  "okicici",
                                  "okhdfcbank",
                                  "okaxis",
                                  "oksbi",
                                ].map((opt) => (
                                  <option key={opt}>{opt}</option>
                                ))}
                              {selectedApp === "Paytm" &&
                                [
                                  "paytm",
                                  "ptyes",
                                  "pthdfc",
                                  "ptaxix",
                                  "ptsbi",
                                ].map((opt) => (
                                  <option key={opt}>{opt}</option>
                                ))}
                            </select>
                          )}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="UPI ID"
                            value={upiInput}
                            onChange={(e) => setUpiInput(e.target.value)}
                            style={{
                              paddingRight: "120px",
                              outline: "none",
                              boxShadow: "none",
                              borderColor: "#ccc",
                            }}
                          />
                        </div>
                        {/* Verify Button */}
                        <div className="mt-3 d-flex justify-content-start">
                          <button
                            disabled={!/^[\w.-]+@[\w.-]+$/.test(upiInput)}
                            style={{
                              backgroundColor: "black",
                              color: "white",
                              borderRadius: "25px",
                              padding: "6px 18px",
                              fontSize: "14px",
                              border: "none",
                              opacity: /^[\w.-]+@[\w.-]+$/.test(upiInput)
                                ? 1
                                : 0.3,
                              transition: "opacity 0.3s ease",
                            }}
                          >
                            Verify UPI ID
                          </button>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey={2} style={getAccordionSpacing(2)}>
                    <Accordion.Header>
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-start">
                          <img
                            src={debit}
                            alt="debit"
                            width={30}
                            height={30}
                            className="me-3"
                          />
                          <div className="d-flex flex-column">
                            <div className="mb-0 fw-bold">
                              Debit/Credit Card
                            </div>
                            <p className="mb-0" style={{ fontSize: "12px" }}>
                              Visa, Mastercard, Rupay, etc.
                            </p>
                          </div>
                        </div>

                        <div
                          className={`custom-radio ${
                            activeKey === 2 ? "active" : ""
                          }`}
                          onClick={() => setActiveKey(2)}
                        >
                          {activeKey === 2 && "✓"}
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                        style={{
                          backgroundColor: "#ECEFF1",
                          borderRadius: "25px",
                          padding: "20px",
                        }}
                      >
                        <div className="mb-3">
                          <label
                            style={{
                              fontWeight: "500",
                              fontSize: "14px",
                              marginBottom: "4px",
                            }}
                          >
                            Card Number
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Your Card Number"
                            className="form-control"
                            style={{
                              backgroundColor: "#fff",
                              borderRadius: "6px",
                              border: "1px solid #ccc",
                              outline: "none",
                              boxShadow: "none",
                            }}
                          />
                        </div>

                        <div className="mb-3">
                          <label
                            style={{
                              fontWeight: "500",
                              fontSize: "14px",
                              marginBottom: "4px",
                            }}
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Your Name"
                            className="form-control"
                            style={{
                              backgroundColor: "#fff",
                              borderRadius: "6px",
                              border: "1px solid #ccc",
                              outline: "none",
                              boxShadow: "none",
                            }}
                          />
                        </div>

                        <div className="d-flex gap-3">
                          <div style={{ flex: 1 }}>
                            <label
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                marginBottom: "4px",
                              }}
                            >
                              Valid Till
                            </label>
                            <div className="d-flex gap-2">
                              <input
                                type="text"
                                placeholder="MM"
                                className="form-control"
                                style={{
                                  backgroundColor: "#fff",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                              />
                              <input
                                type="text"
                                placeholder="YY"
                                className="form-control"
                                style={{
                                  backgroundColor: "#fff",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                              />
                            </div>
                          </div>

                          <div style={{ flex: 1 }}>
                            <label
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                marginBottom: "4px",
                              }}
                            >
                              CVV
                            </label>
                            <div className="d-flex align-items-center gap-2">
                              <input
                                type="password"
                                placeholder="CVV"
                                className="form-control"
                                style={{
                                  backgroundColor: "#fff",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                              />
                              <BsExclamationCircle size={18} color="#999" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey={3} style={getAccordionSpacing(3)}>
                    <Accordion.Header>
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-start">
                          <img
                            src={netBanking}
                            alt="netBanking"
                            width={30}
                            height={30}
                            className="me-3"
                          />
                          <div className="d-flex flex-column">
                            <div className="mb-0 fw-bold">Net Banking</div>
                            <p className="mb-0" style={{ fontSize: "12px" }}>
                              Choose your bank to complete payment
                            </p>
                          </div>
                        </div>
                        <div
                          className={`custom-radio ${
                            activeKey === 3 ? "active" : ""
                          }`}
                          onClick={() => setActiveKey(3)}
                        >
                          {activeKey === 3 && "✓"}
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="card border-0">
                        <div
                          style={{
                            display: "grid",
                            gap: 10,
                            gridTemplateColumns:
                              "repeat(auto-fill, minmax(72px, 1fr))",
                            marginTop: 0,
                          }}
                        >
                          {BanksData.map((app, index) => (
                            <div
                              key={index}
                              className="d-flex flex-column align-items-center justify-content-start"
                              style={appBoxStyle(selectedApp === app.name)}
                              onClick={() => setSelectedApp(app.name)}
                            >
                              <img
                                src={app.img}
                                alt={app.name}
                                width={40}
                                height={40}
                                className="mb-1"
                              />
                              <p
                                className="mb-0"
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                }}
                              >
                                {app.name}
                              </p>
                            </div>
                          ))}
                          <div
                            className="d-flex flex-column align-items-center justify-content-start"
                            onClick={() => setShowMore(true)}
                            style={{
                              height: 88,
                              padding: "8px 0",
                            }}
                          >
                            <div
                              className="d-flex align-items-center justify-content-center mb-1"
                              style={{
                                marginTop: "8px",
                                width: 36,
                                height: 36,
                                padding: "8px 0",
                                border: "1px solid #ccc",
                                borderRadius: 10,
                                cursor: "pointer",
                              }}
                            >
                              <span style={{ fontSize: "18px" }}>...</span>
                            </div>
                            <p
                              className="mb-0"
                              style={{ fontSize: "12px", textAlign: "center" }}
                            >
                              Other
                            </p>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <div className="d-flex justify-content-center align-items-center mt-3">
                  <span
                    className="mb-0 me-2"
                    style={{ fontSize: "12px", color: "#999" }}
                  >
                    Powered By
                  </span>
                  <img src={PhonePeImg} width={80} alt="PhonePay" />
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between align-items-center bg-white w-100 position-absolute bottom-0">
            <div className="d-flex flex-column">
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "24px",
                  color: "#333",
                }}
              >
                <span style={{ fontSize: "20px" }}>₹ </span>
                {amount}
              </div>
              <p
                style={{
                  fontSize: 12,
                  color: "#6720A4",
                  marginBottom: 0,
                }}
              >
                view Breakup
              </p>
            </div>
            {checkStatusLoading ? (
              <Button
                style={{
                  backgroundColor: "#6720A4",
                  fontSize: 20,
                  border: "none",
                  width: 160,
                  padding: "10px 0px",
                }}
                onClick={() => {
                  onClose();
                  checkStatusLoading?.(false);
                }}
              >
                Cancel
              </Button>
            ) : (
              <Button
                disabled={activeKey !== 0}
                style={{
                  backgroundColor: "#6720A4",
                  fontSize: 20,
                  border: "none",
                  width: 160,
                  padding: "10px 0px",
                }}
                onClick={() => {
                  handlePayhubPayment(selectedApp);
                  setLoading(true);
                }}
              >
                {activeKey === 0 ? "Pay Now" : "Unavailable"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </>
  );
};
export default PayhubPay;
